export interface RepaymentHistoryAPIResponse {
  content: Content[];
  pageable: Pageable;
  last: boolean;
  totalPages: number;
  totalElements: number;
  sort: Sort2;
  first: boolean;
  numberOfElements: number;
  size: number;
  number: number;
  empty: boolean;
}

export interface RepaymentMetadata {
  provider: string;
  orderReferenceId: string;
  bankName: string;
  bankAccountNumber: string;
  bankIfsc: string;
  errorCode: string;
  errorDescription: string;
  partnerUtr: string;
}

export interface Content {
  loanReferenceId: string;
  customerReferenceId: string;
  paymentReferenceId: string;
  status: keyof typeof PAYMENT_STATUS;
  valueDate: string;
  businessDate: string;
  repaymentMode: string;
  amount: number;
  failed: boolean;
  success: boolean;
  isDetailRow: boolean;
  toggleState: boolean;
  repaymentMetadata: RepaymentMetadata;
}

export interface Pageable {
  sort: Sort;
  pageNumber: number;
  pageSize: number;
  offset: number;
  paged: boolean;
  unpaged: boolean;
}

export interface Sort {
  sorted: boolean;
  unsorted: boolean;
  empty: boolean;
}

export interface Sort2 {
  sorted: boolean;
  unsorted: boolean;
  empty: boolean;
}

export enum PAYMENT_MODE {
  PAYMENT_GATEWAY = 'Payment Gateway',
  EXCESS_PAYMENT = 'Excess Payment',
  OPS_PORTAL = 'Ops Portal',
  CREDITMATE = 'Credit Mate',
  BBPS = 'BBPS',
  ALLOCATION_REVERSAL = 'Allocation Reversal',
  TOP_UP_TRANSFER = 'Top Up',
  UPI = 'UPI',
  NET_BANKING = 'Net Banking',
  DEDUCTED_AT_DISBURSEMENT = 'Deducted At Disbursement',
  WALLET = 'Wallet',
  CARD = 'Card',
  E_NACH = 'eNACH',
  ENACH = 'eNACH',
  EXCESS_INTEREST = 'Excess Interest',
  ENACH_LINKED = 'eNACH Linked'
}

export enum PAYMENT_STATUS {
  SUCCESS = 'SUCCESS',
  FAILED = 'FAILED',
  FAILURE = 'FAILURE',
  SCHEDULED = 'SCHEDULED',
  UNKNOWN = 'UNKNOWN',
  INITIATED = 'INITIATED'
}
